export default __webpack_public_path__ + "static/media/hayat3.8d7f5c2c.mp4";